import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const rootElement = document.getElementById("root");
const app = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, app, {
    onRecoverableError(error, errorInfo) {
      window.__TB_HYDRATION_ERRORS__ = window.__TB_HYDRATION_ERRORS__ || [];
      window.__TB_HYDRATION_ERRORS__.push({ message: error.message, componentStack: errorInfo?.componentStack || "" });
      console.error("Hydration recoverable error", error, errorInfo);
    },
  });
} else {
  ReactDOM.createRoot(rootElement).render(app);
}

if (window.__TB_PRERENDER_CAPTURE__) {
  const markReady = () => {
    if (rootElement.firstElementChild) {
      requestAnimationFrame(() => { window.__TB_PRERENDER_READY__ = true; });
      return;
    }
    requestAnimationFrame(markReady);
  };
  requestAnimationFrame(markReady);
}
